export default "__VITE_ASSET__39c7b456__"